//I Would Highly Recommend You To Customize The Theme According To Your Taste.
export const globalStyles = {
  "--grad": "linear-gradient(315deg,#48a9fe,#00cdac)", // Use gradients only
  // "--grad": "linear-gradient(315deg, #48a9fe 0%, #734ae8 74%)", // Use gradients only
  // "--grad": "linear-gradient(315deg, #06bcfb 0%, #4884ee 74%)",
  "--txtcolor": "#272341",
  "--p_color": "#00cdac",
  "--s_color": "#fff",
};

// Navigation Bar Name
export const navbar_name = "<Anwar>";

// Main Page
export const main = {
  name: "Anwardeen M",
  doamin: "A MERN Stack Web Developer",
  resume:
    "https://docs.google.com/document/d/1TUGzHQ3H78QclD7C1CxYb-_Mgz0yAQY7wmYqnLZrymg/edit?usp=sharing",
};

// AboutMe
export const aboutme = {
  imgLink:
    "https://github.com/AnwardeenM/Pictures/blob/Trial/DSC05041%20edited-modified.png?raw=true",
  p1: "Hey, My name is Anwardeen. I have completed my Bachelor of Engineering from Mahendra Engineering college,Namakkal,Tamilnadu",
  p2: " I'm a passionate coder and an enthusiastic Web Developer capable of applying programming skills to solve complex problems. Seeking a challenging role in the field of software development that will offer an opportunity for further development of my abilities, skills and knowledge in an organization.",
  p3: "Apart from coding I also like Fitness, Atheletics, read books and explore new things.",
};

// Skills
export const whatido = {
  title: "Full Stack Development",

  details: [
    "Building responsive website using HTML,CSS,JS,React",
    "Creating backend application in Node, ExpressJS",
    "Building Simple RESTful CRUD APIs",
    "Knowledge of MongoDB Database",
    "Knowledge of various UI libraries",
  ],
  logos: [
    {
      name: "HTML5",
      iconifyClassName: "vscode-icons:file-type-html", // PS : Use iconify class name
      id: "1",
    },
    {
      name: "CSS",
      iconifyClassName: "vscode-icons:file-type-css",
      id: "2",
    },
    {
      name: "JavaScript",
      iconifyClassName: "logos:javascript",
      id: "3",
    },
    {
      name: "ReactJS",
      iconifyClassName: "vscode-icons:file-type-reactjs",
      id: "4",
    },
    {
      name: "Redux",
      iconifyClassName: "logos:redux",
      id: "5",
    },
    {
      name: "NodeJS",
      iconifyClassName: "logos:nodejs",
      id: "6",
    },
    {
      name: "ExpressJS",
      iconifyClassName: "logos:express",
      id: "7",
    },
    {
      name: "MongoDB",
      iconifyClassName: "logos:mongodb",
      id: "8",
    },
    {
      name: "Postman",
      iconifyClassName: "logos:postman-icon",
      id: "9",
    },
    {
      name: "npm",
      iconifyClassName: "logos:npm-icon",
      id: "10",
    },
    {
      name: "GIT",
      iconifyClassName: "logos:git",
      id: "11",
    },
    // {
    //   name: "Tailwind",
    //   iconifyClassName: "logos:tailwindcss-icon",
    //   id: "12",
    // },
    {
      name: "Material-UI",
      iconifyClassName: "logos:material-ui",
      id: "13",
    },
    // {
    //   name: "Ant Design",
    //   iconifyClassName: "logos:ant-design",
    //   id: "14",
    // },
    {
      name: "Netlify",
      iconifyClassName: "vscode-icons:file-type-netlify",
      id: "15",
    },
    {
      name: "Vercel",
      iconifyClassName: "logos:vercel-icon",
      id: "16",
    },
  ],
};

// Project Details
export const details = [
  {
    id: 1,
    title: "Pluralsight-clone",
    desc: `Puralsight is an E-learning website where users can explore new things like languages and technologies.`,
    feature: `Sign-in/Sign-up validation with backend,
    corousel image,
Dynamic product page,
payment gateway,Dynamic cart page with coupon functionality.`,
    tech: `Tech Stack: HTML| CSS | JavaScript | nodeJS | express | MongoDB | Heroku`,
    img: "https://github.com/sam7789/pluralsight_clone/blob/main/screenshots/image_2022-04-22_21-46-29.png?raw=true",
    github: "https://github.com/sam7789/pluralsight_clone",
    link: "https://pluralsight-clone-1.netlify.app/"
  },
  {
    id: 2,
    title: "SugarCosmetics Clone",
    desc: `SugarCosmetics is a well known E-commerce website which particularly gives product on the beauty and Make-up there are lots of categories available for shopping.`,
    feature: `Sign-in/Sign-up,
search bar for MakeUp items to see their Beautician contents, explore various beauty cares tracking apps,
Subscription page.`,
    tech: `Tech Stack: HTML | CSS | JavaScript `,
    img: "https://raw.githubusercontent.com/Ajaykvishwakarma/Sugar_Cosmetic/main/landing.png?raw=true",
    link: "https://competent-bardeen-b9ae59.netlify.app/",
    github: "https://github.com/AnwardeenM/Sugar_Cosmetic",
  },
  
//   {
//     id: 6,
//     title: "My Recipe App",
//     desc: `It's a food recipe app, users can search recipes of various dishes and also see the latest recipes as well as the recipe of the day.`,
//     feature: `Search recipe,
// Recipe of the day.`,
//     tech: `Tech Stack: HTML | CSS | JavaScript`,
//     img: "https://github.com/Shivam2101s/images/blob/main/food%20app.jpg?raw=true",
//     link: "https://myfoodapp21.netlify.app/",
//     github: "https://github.com/ashish1234sharma/Food-app",
//   },
];

// Social Media Links
export const links = [
  
  "https://www.linkedin.com/in/anwardeenm/",
  "https://twitter.com/AnwardeenM756/",
  // "https://api.whatsapp.com/send/?phone=918109560498&text&app_absent=0",
  "mailto:kalilanwar597@gmail.com",
  "https://github.com/AnwardeenM",
];
